import { render, staticRenderFns } from "./CalendarsCustome.vue?vue&type=template&id=f5002480&scoped=true"
import script from "./CalendarsCustome.vue?vue&type=script&lang=js"
export * from "./CalendarsCustome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5002480",
  null
  
)

export default component.exports